import { OFFER_GROUP_DOCUMENT_TEMPLATE_MODEL } from "@/models/offer-group-document-template-model";

export const OFFER_GROUP_TEMPLATE_MODEL = "offer-group-template";
export const COPY = "copy";

const offerGroupTemplateModel = {
  displayOrder: 0,
  name: "",
  documents: {
    jsonApi: "hasMany",
    type: OFFER_GROUP_DOCUMENT_TEMPLATE_MODEL
  }
};

export default offerGroupTemplateModel;
